import type { ScaledImage } from '@xing-com/crate-common-graphql-types';
import {
  mediaConfinedOnly,
  mediaSmallOrTiny,
  mediaWide,
} from '@xing-com/layout-tokens';
import { BREAKPOINTS } from '@xing-com/util';

export type CoverMediaImagesUrlType = Partial<
  Record<keyof typeof BREAKPOINTS, string>
>;

export const mediaQueryByBreakpoint: Record<keyof typeof BREAKPOINTS, string> =
  {
    handheld: mediaSmallOrTiny,
    tablet: mediaConfinedOnly,
    desktop: mediaWide,
  };

export const isBreakpointReference = (
  reference: unknown
): reference is keyof typeof BREAKPOINTS => {
  return (
    typeof reference === 'string' &&
    Object.prototype.hasOwnProperty.call(BREAKPOINTS, reference)
  );
};

export const getImagesUrl = (
  coverData: ScaledImage[]
): CoverMediaImagesUrlType | undefined => {
  const initialValue: {
    map: CoverMediaImagesUrlType;
    fallback?: string;
  } = { map: {} };

  const { map, fallback } = coverData.reduce((accumulator, image) => {
    if (!image.url) {
      return accumulator;
    }

    if (isBreakpointReference(image.reference)) {
      accumulator.map[image.reference] = image.url;
      return accumulator;
    }

    if (!accumulator.fallback) {
      accumulator.fallback = image.url;
    }

    return accumulator;
  }, initialValue);

  if (Object.keys(map).length === 0 && fallback) {
    Object.keys(BREAKPOINTS).forEach((reference) => {
      if (isBreakpointReference(reference)) {
        map[reference] = fallback;
      }
    });
  }

  return Object.keys(map).length === 0 ? undefined : map;
};
